import type { NextPage } from "next";
import Template from "@app/Template/Template";
import { CompareScreen } from "@pages/CompareScreen";
import { PROJECT_NAME } from "@shared/config/GlobalText";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";

const Compare: NextPage = () => {
    const title = `Сравнение автомобилей - ${PROJECT_NAME}`;
    const description = `${PROJECT_NAME} - сравнение автомобилей.`;
    const canonicalUrl = `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.COMPARE}`;

    return (
        <Template>
            <CustomHead
                title={title}
                description={description}
                robots={"index,follow"}
                canonical={canonicalUrl}
                openGraph={{
                    title: title,
                    description: description,
                    url: canonicalUrl,
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        alt: title
                    }
                }}
            />
            <CompareScreen />
        </Template>
    );
};

export default Compare;